import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/ru';

dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('ru');

export function timePassed(isoDate: string): string {
    const date = utcDate(isoDate);
    if (!date) return 'нет данных';

    if (date.isToday()) {
        return `сегодня в ${date.format('HH:mm')}`;
    }
    if (date.isYesterday()) {
        return `вчера в ${date.format('HH:mm')}`;
    }

    // return `${date.fromNow()} в ${date.format('HH:mm')}`;
    return `${date.fromNow()}`;
}

export function timeStr(isoDate: string): string {
    const date = utcDate(isoDate);
    return date ? date.format('D MMM, YYYY HH:mm') : '';
}

/**
 * Разбирает дату из UTC-строки в локальное время.
 * @returns null, если строка пустая или дата не валидная
 */
export function utcDate(isoDate: string | null | undefined): dayjs.Dayjs | null {
    if (!isoDate) return null;
    const date = dayjs.utc(isoDate).local();
    return date.isValid() ? date : null;
}
